/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Owner_Cannot_Be_RemovedInputs */

const en_us2_group_owner_cannot_be_removed = /** @type {(inputs: Group_Owner_Cannot_Be_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The group's creator cannot be removed.`)
};

const pt_br2_group_owner_cannot_be_removed = /** @type {(inputs: Group_Owner_Cannot_Be_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem criou a turma não pode ser removido.`)
};

const pt_pt2_group_owner_cannot_be_removed = /** @type {(inputs: Group_Owner_Cannot_Be_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem criou a turma não pode ser removido.`)
};

/** @type {(inputs: Group_Owner_Cannot_Be_RemovedInputs) => LocalizedString} */
const es_419_group_owner_cannot_be_removed = en_us2_group_owner_cannot_be_removed;

/** @type {(inputs: Group_Owner_Cannot_Be_RemovedInputs) => LocalizedString} */
const fr_fr2_group_owner_cannot_be_removed = en_us2_group_owner_cannot_be_removed;

/** @type {(inputs: Group_Owner_Cannot_Be_RemovedInputs) => LocalizedString} */
const de_de2_group_owner_cannot_be_removed = en_us2_group_owner_cannot_be_removed;

/** @type {(inputs: Group_Owner_Cannot_Be_RemovedInputs) => LocalizedString} */
const it_it2_group_owner_cannot_be_removed = en_us2_group_owner_cannot_be_removed;

/**
* | output |
* | --- |
* | "The group's creator cannot be removed." |
*
* @param {Group_Owner_Cannot_Be_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_owner_cannot_be_removed = /** @type {((inputs?: Group_Owner_Cannot_Be_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Owner_Cannot_Be_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_owner_cannot_be_removed(inputs)
	if (locale === "es-419") return es_419_group_owner_cannot_be_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_group_owner_cannot_be_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_group_owner_cannot_be_removed(inputs)
	if (locale === "de-DE") return de_de2_group_owner_cannot_be_removed(inputs)
	if (locale === "it-IT") return it_it2_group_owner_cannot_be_removed(inputs)
	return en_us2_group_owner_cannot_be_removed(inputs)
});
export { group_owner_cannot_be_removed as "group.owner_cannot_be_removed" }